import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./OurPartners.css";
import { ourPartnersImg } from "../../StaticData/ourPartners";
import { Helmet } from "react-helmet";

const OurPartners = () => {
  return (
    <div className="our-partners-page">
      <Helmet>
        <title>Our Partners | Idexcel</title>
        <meta
          content="idexcel partners, idexcel aws partners, idexcel aws competencies"
          name="keywords"
        />
        <meta
          content="Idexcel partners with leading technology companies to provide the best solutions to our clients."
          name="description"
        />
      </Helmet>
      <Container fluid className="our-aws-banner-container p-0">
        <section className="our-aws-banner-section"></section>
      </Container>
      <section className="our-partners-section">
        <Container className="mb-5 px-xl-5">
          <section>
            <h2 className="text-center mb-4 section-title">
              Our <span className="textgrad"> AWS Competencies </span>
            </h2>
            <Row className="m-0 p-0 px-lg-5 d-flex align-items-center flex-column flex-md-row our-partners mt-1 mb-3">
              {ourPartnersImg.map((imgSrc, index) => {
                return (
                  <Col
                  key={index}
                  className={`col-5 col-md-3 col-lg-3 img-wrap my-3 ${
                    index === ourPartnersImg.length - 1 ? "last-item" : ""
                  }`}
                >
                    <div className="p-2 d-flex justify-content-center img-div">
                      <img src={imgSrc.img} alt={`Partner ${index + 1}`} />
                    </div>
                  </Col>
                );
              })}
            </Row>
          </section>
        </Container>
      </section>
    </div>
  );
};

export default OurPartners;
